import React from "react";
import {
    Form,
    Row,
    Col,
    Input,
    Select,
    Button,
    message,Icon
} from "antd";
import img from './../../../assets/img/freepik  Plant  inject 2.png';
import MiCompAPI from "../../../util/api";
import FileBase64 from 'react-file-base64';


const { Option } = Select;

class Compliance extends React.Component {
    constructor(props) {
        super(props);
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err ) {
                if (this.fileData) {
                    if (this.fileData.file.size > 15728640) {
                        message.warning("File size must under 15MiB!", 3);
                    } 
                    else {
                        let data = {
                            ...values, id:0,
                            unq_Document_Name: this.fileData.base64, document_Name: this.fileData.name
                        };
                        this.props.submitHandler(data, (val) => {
                            if (!val) {

                            }
                        });
                    }
                } else {
                    message.error("Plese upload file.", 10)
                }
            }
        });
    };
    
    handleAddReport = (data) => {

        if (data.file.size > 15728640)
        {
            message.warning("File size must under 15MiB!", 3);
        }       
        this.fileData = data;
    }
   
    render() {
        const { getFieldDecorator } = this.props.form;
        const { decodedToken } = this.props.userPermandMasters;
        var role = decodedToken.UserRoleName;
        return (
            <div className="mi_model_popup">
                <Row span={24}>
                    <Col span={18}>
                        <p className='mi_title' style={{ marginLeft: '8px' }}>Add Report
                            <br></br>
                            <span className='mi_title2'>Fill up the following form in order to new a Report</span>
                        </p>

                    </Col>
                    <Col span={6}>
                        <i className="fa fa-times mi_icon mi_icon_red mi_button_close" onClick={this.props.closeDrawerHandler} ></i>
                    </Col>
                </Row>
                <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                    <Row span={24}>
                        <Col md={24} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Report Name</legend>

                                    {getFieldDecorator('report_Name', {
                                        rules: [{ required: true, message: 'Please Enter Report Name' }],
                                    })(<Input className="mi_input"  maxLength={40} type="text" placeholder="Please enter Report Name*" />)}


                                </fieldset>
                            </Form.Item>

                        </Col>
                        <Col md={24} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Producer</legend>

                                    {getFieldDecorator('entity_Id', {
                                        rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select a Producer  </span> }],
                                    })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input" placeholder="Please Select *">
                                      {this.props&&this.props.users&&this.props.users.map(x=>{
                                        return <Option value={x.id} key={x.id}>{x.name}</Option>
                                      })}  
                                    </Select>)}

                                </fieldset>
                            </Form.Item>
                        </Col>                      
                        <Col md={24} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Report File</legend>
                                    <FileBase64 onDone={this.handleAddReport} />                                   
                                </fieldset>
                            </Form.Item>
                        </Col>

                    </Row>

                    <Row span={24} style={{ marginTop: '30px' }}>
                        <Col span={7}>

                        </Col>
                        <Col span={5}>

                            <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                                Cancel
                            </Button>

                        </Col>
                        <Col span={5}>

                            <Button htmlType="submit"  className="submit-button" type="primary" >
                                Submit
                            </Button>

                        </Col>
                        <Col span={7}>
                            <img alt="example" style={{ height: '70px', marginBottom: '-30px', float: 'right' }} src={img} />
                        </Col>
                        <Col span={7}>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const AddReports = Form.create()(Compliance);
export default AddReports;
